import React, { FC, memo, useCallback } from 'react';

import { Tooltip } from '../../../../Tooltip/Tooltip';
import styles from './AudioPlayerSpeed.styles.m.css';

interface IAudioPlayerSpeedProps {
  currentSpeed: number;
  isDisabled: boolean;
  onChange(speed: number): void;
  tooltipText?: string;
}

const SPEED_OPTIONS: number[] = [1, 1.5, 2];

export const AudioPlayerSpeed: FC<IAudioPlayerSpeedProps> = memo((props) => {
  const { currentSpeed, isDisabled = false, onChange, tooltipText = 'Speed' } = props;
  const changeSpeed = useCallback(() => {
    const newSpeed = SPEED_OPTIONS.find((item) => item > currentSpeed) || SPEED_OPTIONS[0];
    onChange(newSpeed);
  }, [currentSpeed, onChange]);

  return (
    <Tooltip text={tooltipText}>
      <button
        className={styles.button}
        type="button"
        disabled={isDisabled}
        onClick={changeSpeed}
      >
        {currentSpeed}x
      </button>
    </Tooltip>
  );
});
